import { useFormik } from "formik";
import { passwordSchema } from "../utils/validations";
import { useChangePasswordMutation } from "../store";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";
import { showToast, ToastType } from "../utils/toast.utils";

const ChangePasswordForm = () => {
  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const { handleSubmit, handleChange, handleBlur, values, errors, touched } =
    useFormik({
      initialValues: {
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      },
      validationSchema: passwordSchema,
      onSubmit: async (values, { resetForm }) => {
        const result = await changePassword({
          oldPassword: values.oldPassword,
          newPassword: values.newPassword,
        });
        if (!result.error) {
          showToast("Mot de passe modifié", ToastType.SUCCESS);
          resetForm();
        }
      },
    });

  return (
    <div className="bg-white p-6 rounded shadow-lg border border-gray-100">
      <h2 className="text-xl font-semibold mb-4 text-primary">Sécurité</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        <TextField
          id="oldPassword"
          placeholder="Mot de passe actuel"
          hideable
          value={values.oldPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
        <TextField
          id="newPassword"
          placeholder="Nouveau mot de passe"
          hideable
          value={values.newPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
        <TextField
          id="confirmNewPassword"
          placeholder="Confirmer nouveau mot de passe"
          hideable
          value={values.confirmNewPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
        <Button
          type="submit"
          disabled={isLoading}
          className="mt-2 bg-primary text-white py-2 rounded font-bold justify-center"
        >
          Changer le mot de passe
        </Button>
      </form>
    </div>
  );
};

export default ChangePasswordForm;
